<template>
  <div>
    <n-tooltip :trigger="(props.trigger as PopoverTrigger)" :disabled="!tipsText" style="max-width: 400px">
      {{ tipsText }}
      <template #trigger>
        <n-select
          :value="props.value"
          :fallback-option="fallbackOptionFn"
          style="flex-shrink: 0"
          :disabled="disabled"
          :size="size"
          :options="options"
          :filterable="filterable"
          :render-option="renderOption"
          :placeholder="placeholder"
          :label-field="labelField"
          :value-field="valueField"
          :clearable="clearable"
          :status="status"
          :multiple="multiple"
          v-bind="$attrs"
          @update:value="update"
          @change="change"
        >
          <template v-for="(item, key, index) in $slots" :key="index" #[key]>
            <slot :name="key"></slot>
          </template>
        </n-select>
      </template>
    </n-tooltip>
  </div>
</template>
<script lang="ts" setup>
import { h, VNode, computed } from 'vue';
import { SelectOption, NTooltip, PopoverTrigger } from 'naive-ui';

interface Options {
  value?: string;
  label?: string;
}

const props: any = defineProps({
  tips: {
    type: String,
    default: 'hover',
  },
  trigger: {
    type: String,
    default: 'hover',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: 'medium',
  },
  value: {
    type: String || Number || Array,
    default: null,
  },
  placeholder: {
    type: String || Number,
    default: '',
  },
  options: {
    type: Array,
    default: () => [],
  },
  filterable: {
    type: Boolean,
    default: false,
  },
  fallbackOption: {
    type: Function,
    default: undefined,
  },
  labelField: {
    type: String,
    default: 'label',
  },
  valueField: {
    type: String,
    default: 'value',
  },
  status: {
    type: String,
  },
  multiple: {
    type: Boolean,
  },
  clearable: {
    type: Boolean,
  },
});

const modelValues: any = computed(() => {
  return props.values;
});

const $emits = defineEmits(['update:value', 'change']);

const renderOption = ({ node, option }: { node: VNode; option: SelectOption }) => {
  return h(
    NTooltip,
    {
      style: {
        width: '140%',
      },
    },
    {
      trigger: () => node,
      default: () => option[props.labelField],
    }
  );
};

const update = (value: string, option: SelectOption) => {
  $emits('update:value', value, option);
};

const change = (value: string, option: SelectOption) => {
  $emits('change', value, option);
};

const tipsText = computed(() => {
  if (props.multiple) {
    const dataArray = props.options.filter((item: any) =>
      props.value.includes(item[props.valueField])
    ) as Array<Options>;
    return dataArray?.length && dataArray.map((it: any) => it[props.labelField])?.join(',');
  } else {
    const data = props.options.find((item: any) => item[props.valueField] === props.value) as Options;
    return data && data[props.labelField];
  }
});
const fallbackOptionFn = computed(() => {
  return props.fallbackOption ? props.fallbackOption : false;
});
</script>
